import { ChangeDetectorRef, ErrorHandler, Inject, Injectable, Injector, NgZone } from "@angular/core";
import { MessageService } from "./message.service";



@Injectable() 
export class CustomErrorHandler implements ErrorHandler {

  constructor(private injector: Injector) { 

  }
  handleError(error) {
    if (error?.message?.indexOf("ExpressionChangedAfterItHasBeenCheckedError") >= 0) {
      console.error(error);
      return;
    }
    const debug = window.location.href.indexOf("debug=true") >= 0;
    if (debug) {
      alert("CUSTOM ERROR HANDLER:"+ JSON.stringify(error));
    }

    console.error("CUSTOM ERROR HANDLER", error);

    this.injector.get(NgZone).run(() => {
      let messages =this.injector.get(MessageService);
      messages.sendError(error);
    })


    // do something with the exception
  }
}
